import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CartIcon from '../../icons/cart';
import AddToCart from '../AddToCart';
import ReadMore from '../ReadMore';

export default function SeriesTwo() {

  document.title = `Series Two | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Our second series gathers works of poetry, fiction, art and autobiography from across the diffuse planetary avant-garde of today, with books by McKenzie Wark, Bora Chung, Enrique Vila-Matas, Vivek Narayanan, and the cult duo of Raymond Pettibon and Mike Topp.`);


  return (
    <div className=''>

      <div className='booksPage'>


        <h5>Series II</h5>

        <p className='seriesGraf'>Our second series gathers works of poetry, fiction, art and autobiography from across the diffuse planetary avant-garde of today, with books by McKenzie Wark, Bora Chung, Enrique Vila-Matas, Vivek Narayanan, and the cult duo of Raymond Pettibon and Mike Topp. It also includes a reissue of beloved Hanuman author Cookie Mueller’s <em>Fan Mail, Frank Letters, and Crank Calls</em>, from the original catalogue.
        </p>
        <ReadMore>
          <p><strong>Design Note</strong></p>
          <br />
          <p>
            For Series II, we turned to Russian artist Kazimir Malevich’s geometric costumes and early Suprematist set design for 1913 opera <em>Victory over the Sun</em>, with its libretto composed in the Futurist language of “zaum” and raucous musical score. The flamboyant colors of Malevich’s absurdist characters were adopted as Series II’s book covers, conjuring architectonic reinventions of the human in a provocation for the present.
          </p>
        </ReadMore>


        <div className='gridThree'>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/life-story-mckenzie-wark' className='gridThree_bookCover' style={{
                background: `url(../../Series-Two/McKenzieWark_01_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}></Link>

            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Life Story</div>
                <div className='nb-author'>McKenzie Wark</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378067'} />
              </div>
            </div>
          </div>

          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/grocery-list-bora-chung' className='gridThree_bookCover' style={{
                background: `url(../../Series-Two/BoraChung_02_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}></Link>

            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Grocery List</div>
                <div className='nb-author'>Bora Chung</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416529'} />
              </div>
            </div>

          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/frontier-index-raymond-pettibon-mike-top' className='gridThree_bookCover' style={{
                background: `url(../../Series-Two/RaymondPettibonTopp_05_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>The Frontier Index</div>
                <div className='nb-author'>Raymond Pettibon & Mike Topp</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416512'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/insistence-as-a-fine-art-enrique-vila-matas' className='gridThree_bookCover' style={{
                background: `url(../../Series-Two/EnriqueVila-Matas_03_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls '>
              <div className='gridThree_description'>
                <div className='nb-title'>Insistence as a Fine Art</div>
                <div className='nb-author'>Enrique Vila-Matas</div>
              </div>
              <div className='gridThree_addToCart'>
                <AddToCart context={'landing'} id={'9798990416505'} />
              </div>
            </div>
          </div>


          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/kuruntokai-vivek-narayanan' className='gridThree_bookCover' style={{
                background: `url(../../Series-Two/VivekNarayanan_04_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>

            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>The Kuruntokai and Its Mirror</div>
                <div className='nb-author'>Vivek Narayanan</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378098'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/fan-mail-frank-letters-crank-calls-cookie-mueller' className='gridThree_bookCover' style={{
                background: `url(../../Series-Two/Fanmail_Side.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Fan Mail, Frank Letters and Crank Calls</div>
                <div className='nb-author'>Cookie Mueller</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378081'} />
              </div>
            </div>
          </div>
        </div>
        <div className='boxGrid'>
          <div className='boxGrid_item'>
            <div className='boxGrid_image'>
              <div className='boxGrid_graphic' style={{ backgroundImage: `url(../../Boxsets/Series_2_Multiview_Boxset_Flamingo.png)` }}></div>
            </div>
            <div className='boxGrid_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Series II Box Set</div>
                <div className='nb-author'>Flamingo</div>
              </div>
              <div>
                <AddToCart context='landing' id={'hanuman_box_02_fl'} />
              </div>
            </div>
          </div>
          <div className='boxGrid_item'>
            <div className='boxGrid_image'>
              <div className='boxGrid_graphic' style={{ backgroundImage: `url(../../Boxsets/Series_2_Multiview_Boxset_TabrizBlue.png)` }}></div>
            </div>
            <div className='boxGrid_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Series II Box Set</div>
                <div className='nb-author'>Tabriz Blue</div>
              </div>
              <div>
                <AddToCart context='landing' id={'hanuman_box_02_tb'} />
              </div>
            </div>
          </div>
          <div className='boxGrid_item'>
            <div className='boxGrid_image'>
              <div className='boxGrid_graphic' style={{ backgroundImage: `url(../../Boxsets/Series_2_Multiview_Boxset_NewBlue.png)` }}></div>
            </div>
            <div className='boxGrid_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Series II Box Set</div>
                <div className='nb-author'>New Blue</div>
              </div>
              <div>
                <AddToCart context='landing' id={'hanuman_box_02_nb'} />
              </div>
            </div>
          </div>
          <div className='boxGrid_item'>
            <div className='boxGrid_image'>
              <div className='boxGrid_graphic' style={{ backgroundImage: `url(../../Boxsets/Series_2_Multiview_Boxset_Citrine.png)` }}></div>
            </div>
            <div className='boxGrid_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Series II Box Set</div>
                <div className='nb-author'>Citrine</div>
              </div>
              <div>
                <AddToCart context='landing' id={'hanuman_box_02_ct'} />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}